module.exports = __webpack_public_path__ + "media/assets/KBL-5720faaa4b8a7315aa4fccd52466c89b22059a8bba326f8530832d8d70206c99.png";